export enum FormAction {
  UPDATE = 'UPDATE',
  UNSUBSCRIBE = 'UNSUBSCRIBE'
}
